export const capitalizeFirstLetter = (text: any) => {
    if (text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
}

export const hasNumbers = (str: any) => {
    return /\d/.test(str);
};